import { render, staticRenderFns } from "./BeVenueNavbar.vue?vue&type=template&id=354ed965&scoped=true"
import script from "./BeVenueNavbar.vue?vue&type=script&lang=js"
export * from "./BeVenueNavbar.vue?vue&type=script&lang=js"
import style0 from "./BeVenueNavbar.vue?vue&type=style&index=0&id=354ed965&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354ed965",
  null
  
)

export default component.exports